import { Button, Col, Form, Row, Select, Space } from 'antd';

const { Option } = Select;

interface RegisterFAComponent1Props {
  onCreate: (data: any) => void;
}
function RegisterFAComponent1({ onCreate }: RegisterFAComponent1Props) {
  const [form] = Form.useForm();

  return (
    <>
      <Form
        form={form}
        name="requestAuthCode"
        initialValues={{ isRefund: true, clientType: '0' }}
        onFinish={() => {
          form
            .validateFields()
            .then((values) => {
              onCreate(values);
            })
            .catch((info) => {
              console.error('Validate Failed:', info);
            });
        }}
      >
        <Row justify="center">
          <Col span={18}>
            <Form.Item
              name="clientType"
              label="카드종류"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <Select style={{ width: '100%' }}>
                <Option key="0" value="0">
                  개인카드
                </Option>
                <Option key="1" value="1">
                  법인카드
                </Option>
              </Select>
            </Form.Item>
          </Col>
        </Row>
        <Form.Item
          noStyle
          shouldUpdate={(prevValues, currentValues) =>
            prevValues.clientType !== currentValues.clientType
          }
        >
          {({ getFieldValue }) =>
            getFieldValue('clientType') === '0' ? (
              <Row justify="center">
                <Col span={18}>
                  <Form.Item
                    name="isRefund"
                    label="경비환급"
                    rules={[
                      {
                        required: true,
                      },
                    ]}
                  >
                    <Select style={{ width: '100%' }}>
                      <Option key="0" value={true}>
                        예
                      </Option>
                      <Option key="1" value={false}>
                        아니오
                      </Option>
                    </Select>
                  </Form.Item>
                </Col>
              </Row>
            ) : null
          }
        </Form.Item>

        <Row justify="center" style={{ marginTop: '50px' }}>
          <Col span={18}>
            <Form.Item>
              <Row justify="center">
                <Space size="middle">
                  {/* <Button
                  htmlType="button"
                  onClick={() => updateUserPhone(form1.getFieldValue('phone'))}
                  disabled={
                    !(verifiedAuthCode && verifiedAuthCode.type === 'success')
                  }
                >
                  다음
                </Button> */}
                  <Button type="primary" htmlType="submit">
                    다음
                  </Button>
                </Space>
              </Row>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </>
  );
}

export default RegisterFAComponent1;
